module.exports = __webpack_public_path__ + "static/media/es.d18de46b.svg";